import { Component, inject, signal } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { CAREER_API, provideCareerApi } from '../../../../api/services/career.service';
import { NOTIFICATION_SERVICE } from '../../../../shared/notification/notification';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';
import {
	createErrorNotification,
	createSuccessNotification,
} from '../../../../shared/notification/notification.factory';

@Component({
	selector: 'lvr-career-delete-dialog',
	template: `
		<h2 mat-dialog-title>{{ 'client.career.delete_title' | transloco }}</h2>
		<mat-dialog-content>
			<p>
				{{ 'client.career.delete_confirmation' | transloco }}
			</p>
			<p>{{ 'client.career.no_revert' | transloco }}</p>
		</mat-dialog-content>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'client.career.cancel' | transloco"
				[type]="'button'"
				[icon]="'disabled_by_default'"
				mat-dialog-close
			></lvr-button>
			<lvr-button
				variant="primary"
				[label]="'client.career.delete' | transloco"
				[type]="'button'"
				[loading]="loading()"
				[loadingLabel]="'base.button.deleting' | transloco"
				(clicked)="deleteCareer()"
				[icon]="'delete'"
			></lvr-button>
		</mat-dialog-actions>
	`,
	styles: [
		`
			.full-width {
				width: 100%;
				margin-top: 16px;
			}
		`,
	],
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	providers: [provideCareerApi],
})
export class CareerDeleteDialog {
	private readonly dialogRef = inject(MatDialogRef<CareerDeleteDialog>);
	private readonly data = inject(MAT_DIALOG_DATA) as {
		careerId: number;
		clientId: number;
		onDeleted: () => Promise<void>;
	};
	private readonly careerApi = inject(CAREER_API);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly transloco = inject(TranslocoService);

	public readonly loading = signal(false);

	public async deleteCareer() {
		this.loading.set(true);

		try {
			await this.careerApi.removeEntry(this.data.clientId, this.data.careerId);
			await this.data.onDeleted();
			this.ntfySrv.addNotification(
				createSuccessNotification(this.transloco.translate('base.notification_message.career_deleted')),
			);
			this.dialogRef.close(true);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (_: unknown) {
			this.ntfySrv.addNotification(
				createErrorNotification(this.transloco.translate('base.notification_message.career_delete_error')),
			);
		} finally {
			this.loading.set(false);
		}
	}
}
